<template>
  <div
    v-show="consented"
    class="onetrust-blocker"
  >
    <div class="onetrust-blocker__block">
      <p>
        {{ settings.message }}
      </p>
      <div>
        <c-button
          ref="button"
          use-custom-button="secondary"
          @click="onClick"
        >
          {{ settings.button }}
        </c-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CButton from '@atoms/button/button.vue'

export default {
  name: 'onetrust-blocker',
  components: {
    CButton
  },
  props: {
    requiredCookie: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'settings',
      'consented'
    ]),
  },
  watch: {
    consented() {
      const { button } = this.$refs
      button.innerText = this.settings.button
    }
  },
  methods: {
    onClick() {
      window.OneTrust.ToggleInfoDisplay()
    }
  }
}
</script>

<style lang="scss" scoped>
.onetrust-blocker {
  background: $white;
  width: 100%;
  height: 100%;

  &__block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 1.875rem;
    height: 100%;

    & p {
      margin-bottom: 0.9375rem;
      font-weight: normal;
      max-width: 37.5rem;
      text-align: center;
    }
  }
}

</style>
